import { yupResolver } from "@hookform/resolvers/yup";
import {
  Badge,
  Button,
  Card,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useParams, useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { SketchPicker } from "react-color";
import ImageUploading from "react-images-uploading";
import DefaultProfileImg from "../../assets/images/defaultProfileImg.jpg";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import Chip from "@mui/material/Chip";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimeField } from "@mui/x-date-pickers";
import { toast } from "react-hot-toast";
import { topicsEditApi } from "../../store/topics/topicsEdit";
import { topicsAddApi } from "../../store/topics/topicsAdd";
import { topicsDetailsApi, resettopics } from "../../store/topics/topicsDetail";
import { classGlobalApi } from "../../store/class/classListGlobal";
import { subjectGlobalApi } from "../../store/subject/subjectListGlobal";
import { useTheme } from '@mui/material/styles';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName !== name
      ? theme.typography.fontWeightRegular
      : theme.typography.fontWeightMedium,
  };
}
const schema = yup
  .object({
    title: yup.string().required("please provide a topic name ").trim(),
  })
  .required();

export default function TopicsEdit() {
  const topicsDetails = useSelector((state) => state?.topicsDetails);
  const { result: classList, loading: classLoading } = useSelector((state) => state?.classGlobal);
  const { result: subjectList, loading: subjectLoading } = useSelector((state) => state?.subjectGlobal);
  const theme = useTheme();

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const params = useParams();
  const navigate = useNavigate();
  const topicsAdd = useSelector((state) => state?.topicsAdd);
  const topicsEdit = useSelector((state) => state?.topicsEdit);
  useEffect(() => {
    if (params.id) {
      dispatch(topicsDetailsApi(params.id));
    }
    dispatch(classGlobalApi());
    dispatch(subjectGlobalApi());
    return () => {
      dispatch(resettopics())
    }
  }, [dispatch]);

  const handleUpdateForm = async (value) => {
    try {

      var newObj;
      if (value.title_hn === '')
        delete value.title_hn
      if (params.id) {
        newObj = { ...value, id: params.id };
        await dispatch(topicsEditApi(newObj));
        if (!topicsEdit?.loading) {
          navigate("/topics-management");
        }
      } else {
        await dispatch(topicsAddApi(value));
        if (!topicsAdd?.loading) {
          navigate("/topics-management");
        }
      }
    } catch (error) {
      console.log("error", error)
    }
  };

  useEffect(() => {
    let defalutValues = {};
    if (params.id) {
      defalutValues["title"] = topicsDetails.result?.title;
      defalutValues["title_hn"] = topicsDetails.result?.title_hn;
      defalutValues["class_ids"] = topicsDetails.result?.classes?.map(o => o?.id);
      defalutValues["subject_id"] = topicsDetails.result?.subject?.id;
    }
    reset(defalutValues);
  }, [topicsDetails]);

  return (
    <>
      <Appbar />
      <Drawer />
      <Body>
        <form onSubmit={handleSubmit(handleUpdateForm)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card>
                <Typography>Topic Details</Typography>
                <Stack spacing={2} my={2}>
                  <Divider />

                  <Stack direction="row" spacing={2}>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel htmlFor="outlined-adornment-category" shrink>
                        Title
                      </InputLabel>
                      <OutlinedInput
                        {...register("title")}
                        label="title"
                        notched
                        id="outlined-adornment-category"
                        error={errors?.title?.message}
                      />
                      <FormHelperText error>
                        {errors?.title?.message}
                      </FormHelperText>
                    </FormControl>

                    <FormControl variant="outlined" fullWidth>
                      <InputLabel htmlFor="outlined-adornment-category" shrink>
                        Title (Hindi)
                      </InputLabel>
                      <OutlinedInput
                        {...register("title_hn")}
                        label="title_hn"
                        notched
                        id="outlined-adornment-category"
                        error={errors?.title_hn?.message}
                      />
                      <FormHelperText error>
                        {errors?.title_hn?.message}
                      </FormHelperText>
                    </FormControl>
                  </Stack>
                  <Stack direction="row" spacing={2}>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel htmlFor="outlined-adornment-email" shrink>
                        Class
                      </InputLabel>
                      <Controller
                        name="class_ids"
                        control={control}
                        defaultValue={[]}
                        render={({ field }) => (
                          <Select
                            {...field}
                            multiple
                            value={watch('class_ids', [])}
                            onChange={(e) => {
                              const {
                                target: { value },
                              } = e;
                              setValue('class_ids', typeof value === 'string' ? value.split(',') : value);
                              field.onChange(e);
                            }}
                            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                            renderValue={(selected) => (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {selected.map((value) => (
                                  <Chip key={value} label={classList.find(obj => obj.id === value)?.title || ""} />
                                ))}
                              </Box>
                            )}
                            MenuProps={MenuProps}
                          >
                            {classList.map((obj) => (
                              <MenuItem
                                key={obj.title}
                                value={obj.id}
                                style={getStyles(obj.title, watch('class_ids', []), theme)}
                              >
                                {obj.title}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                      {errors.class_ids && <span>{errors.class_ids.message}</span>}
                      <FormHelperText error>
                        {errors?.class_ids?.message}
                      </FormHelperText>
                    </FormControl>

                    <FormControl variant="outlined" fullWidth>
                      <InputLabel htmlFor="outlined-adornment-email" shrink>
                        Subject
                      </InputLabel>
                      <Controller
                        name="subject_id"
                        control={control}
                        defaultValue={""}
                        render={({ field }) => (
                          <Select
                            {...field}
                            // multiple
                            value={watch('subject_id', "")}
                            onChange={(e) => {
                              const {
                                target: { value },
                              } = e;
                              setValue('subject_id', typeof value === 'string' ? value.split(',') : value);
                              field.onChange(e);
                            }}
                            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                            renderValue={(selected) => (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                <Chip key={selected} label={subjectList.find(obj => obj.id === selected)?.title || ""} />
                              </Box>
                            )}
                            MenuProps={MenuProps}
                          >
                            {subjectList.map((obj) => (
                              <MenuItem
                                key={obj.title}
                                value={obj.id}
                                style={getStyles(obj.title, watch('subject_id', ""), theme)}
                              >
                                {obj.title}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                      {errors.subject_id && <span>{errors.subject_id.message}</span>}
                      <FormHelperText error>
                        {errors?.subject_id?.message}
                      </FormHelperText>
                    </FormControl>
                  </Stack>
                </Stack>
              </Card>
              <Button
                type="button"
                sx={{ float: "right", mt: 2, ml: 2 }}
                variant="contained"
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                sx={{ float: "right", mt: 2 }}
                variant="contained"
              >
                {params.id ? "Update" : "Create"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Body>
    </>
  );
}
